import { formatDateIso } from '../../dateTime';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { RhinoProgram } from './type';
import { searchLiveProgram } from './utils';

export type GetChannelLiveProgramArgs = {
  channelId: number;
  timestamp: number;
};

export function getChannelLiveProgram({ channelId, timestamp }: GetChannelLiveProgramArgs) {
  const date = new Date(timestamp);
  const programs = queryClient.getQueryData<RhinoProgram[]>(queryKeys.channelPrograms(channelId, formatDateIso(date)));

  if (!programs) {
    return undefined;
  }

  return searchLiveProgram(programs);
}
